export default __webpack_public_path__ + "static/media/20D.2e415f06.jpg";